<template>
<div class="heat-meter-container">
  <div class="metric-pointer" :style="`margin-left: ${getLeadingOffset()}%;`">
    <v-icon size="60px" color="black">mdi-chevron-down</v-icon>
  </div>
  <div class="metric"/>
</div>
</template>

<script>
export default {
  name: "HeatMeter",
  props: ["obj"],
  methods: {
    getLeadingOffset() {
      if (this.obj && typeof this.obj.status === 'number' && this.obj.status >= 0 && this.obj.status <= 5) {
        return Math.round(((5 - this.obj.status) / 5) * 100);
      }
    }
  }
}
</script>


<style scoped lang="scss">
.metric-pointer {
  position: absolute;
  top: 0px;
}
</style>